import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initSentry } from './config/sentry';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Register service worker for push notifications
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/service-worker.js')
    .then((registration) => {
      console.log('Service worker registered:', registration);
    })
    .catch((err) => {
      console.warn('Service worker registration failed:', err);
    });
}
